import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { themeSpace } from '@utils/styledTheme.util';
import { LoadingTextStyles } from '@components/typography/interVariants';

export const SpinnerWrapper = styled(Flex)`
  height: 90%;
  gap: ${themeSpace(4)};
`;

export const Spinner = styled.div`
  width: 74px;
  height: 74px;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  div {
    width: 6%;
    height: 16%;
    background: #5f2698;
    position: absolute;
    left: 49%;
    top: 43%;
    opacity: 0;
    border-radius: 50px;
    animation: fade 1s linear infinite;

    @keyframes fade {
      from {
        opacity: 1;
      }
      to {
        opacity: 0.25;
      }
    }
  }
`;

export const Bar = styled.div<{ rotate: string; delay: string }>`
  transform: rotate(${({ rotate }) => rotate}) translate(0, -130%);
  animation-delay: ${({ delay }) => delay} !important;
`;

export const SpinnerText = styled(Text)`
  ${LoadingTextStyles};
`;
